





import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
//@ts-ignore
import YimoVueEditor, { E } from 'yimo-vue-editor'

@Component({
  components: { YimoVueEditor }
})
export default class BaseEditor extends Vue {
  @Prop({ required: false, type: String, default: '' }) value!: string

  text = ''

  config = {
    printLog: false, // disabled console.log
    lang: E.langs.en // lang config
  }

  @Watch('text') watchText(new_: string) {
    if (new_ !== '') {
      this.$emit('change', new_)
    }
  }

  setData(text: string) {
    this.text = text
  }

  reset() {
    this.text = ''
  }

  created() {
    console.log('create', this.value)
    if (this.value && this.value !== '') {
      this.text = this.value
    }
  }
}
